module.exports = __webpack_public_path__ + "static/media/middle_logo.810cf7f1.svg";